import { useState } from 'react';
import { Map as ImmutableMap } from 'immutable';
import * as SearchApi from 'documents-ui/api/SearchApi';
import { Image } from 'foundations-components/transitional/components/Image';
import { canWrite } from 'documents-ui/lib/permissions';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import IndexTableRowHoverButtonsSlot from 'SalesContentIndexUI/slots/IndexTableRowHoverButtonsSlot';
import IndexTableRowHoverCell from 'SalesContentIndexUI/components/IndexTableRowHoverCell';
import IndexTableRowHoverDropdown from 'SalesContentIndexUI/components/IndexTableRowHoverDropdown';
import createFolderNavModal from 'SalesContentIndexUI/components/folderNav/createFolderNavModal';
import MoveFolderHoverButton from 'SalesContentIndexUI/components/hoverButtons/MoveFolderHoverButton';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import CreateLinkPrompt from '../createLink/CreateLinkPrompt';
import CreateLinkHoverButton from './hoverButtons/CreateLinkHoverButton';
import PreviewHoverButton from './hoverButtons/PreviewHoverButton';
import DownloadHoverButton from './hoverButtons/DownloadHoverButton';
import ShareHoverButton from './hoverButtons/ShareHoverButton';
import DescriptionHoverButton from './hoverButtons/DescriptionHoverButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DocumentNameCell = ({
  searchResult,
  moveDocuments,
  downloadDocument,
  fetchDocumentDescription,
  toggleDocumentDescription,
  description
}) => {
  const [showFolderNavModal, setShowFolderNavModal] = useState(false);
  const deckId = searchResult.contentId;
  const deckTitle = searchResult.name || '';
  const {
    showCreateLinkModal,
    renderCreateLinkModal
  } = CreateLinkPrompt({
    deckId,
    name: deckTitle,
    gdprSettings: null
  });
  const renderFolderNavModal = () => {
    if (!showFolderNavModal) {
      return null;
    }
    const FolderNavModal = createFolderNavModal(SearchApi.search, SearchContentTypes.DOCUMENTS_FOLDER);
    const searchResults = ImmutableMap([searchResult].map((result, index) => [index, result]));
    return /*#__PURE__*/_jsx(FolderNavModal, {
      searchResults: searchResults,
      onConfirm: selectedFolder => {
        setShowFolderNavModal(false);
        return moveDocuments(ImmutableMap([[searchResult.contentId, searchResult]]), selectedFolder);
      },
      onClose: () => setShowFolderNavModal(false)
    });
  };
  const renderImage = () => {
    const thumbnailUrl = searchResult.metadata ? searchResult.metadata.get('thumbnailUrl') : null;
    if (!thumbnailUrl) {
      return null;
    }
    return /*#__PURE__*/_jsx(Image, {
      marginInlineEnd: "300",
      shape: "thumbnail",
      alt: "",
      src: thumbnailUrl,
      responsive: false,
      maxInlineSize: "30px",
      maxBlockSize: "30px"
    });
  };
  const renderButtons = () => {
    if (!deckId) {
      return null;
    }
    return /*#__PURE__*/_jsxs(IndexTableRowHoverButtonsSlot, {
      children: [/*#__PURE__*/_jsx(DescriptionHoverButton, {
        deckId: deckId,
        deckTitle: deckTitle,
        isLoading: description.isLoading,
        fetchDocumentDescription: fetchDocumentDescription,
        toggleDocumentDescription: toggleDocumentDescription
      }), /*#__PURE__*/_jsx(PreviewHoverButton, {
        deckId: deckId
      }), /*#__PURE__*/_jsxs(IndexTableRowHoverDropdown, {
        children: [/*#__PURE__*/_jsx(CreateLinkHoverButton, {
          handleShowCreateLinkModal: showCreateLinkModal
        }), /*#__PURE__*/_jsx(DownloadHoverButton, {
          deckId: deckId,
          name: deckTitle,
          downloadDocument: downloadDocument
        }), canWrite() && /*#__PURE__*/_jsx(MoveFolderHoverButton, {
          onClick: () => setShowFolderNavModal(true)
        }), canWrite() && /*#__PURE__*/_jsx(ShareHoverButton, {
          searchResult: searchResult,
          buttonProps: {
            use: 'link',
            className: 'm-x-0'
          }
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IndexTableRowHoverCell, {
      content: /*#__PURE__*/_jsx(RouterLink, {
        to: `/summary/${searchResult.contentId}`,
        onClick: () => {
          toggleDocumentDescription({
            isOpen: false
          });
        },
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          children: [renderImage(), /*#__PURE__*/_jsx(TruncateString, {
            children: searchResult.name
          })]
        })
      }),
      buttons: renderButtons()
    }), renderFolderNavModal(), renderCreateLinkModal()]
  });
};
export default DocumentNameCell;